module.exports = __webpack_public_path__ + "img/77301.3a7863c0.svg";